(function() {
	/**
	 * Renders Climate Charts Page
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object}  Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderClimateChartsPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/climate-charts.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, // Comes from renderMainContent()
				pageRaw: null,
				pageContent: null,
				navRaw: null,
				nav: null
			}
		};
		var fetchAsync = WebBaseAprovLV.Utils.fetchAsync({
			dataType: 'json',
			cache: false
		});
		var base = (WebBaseAprovLV.config.azureStorageUrl[WebBaseAprovLV.lang] || '');
		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		)
		.then(function(pageXhr, tmplPage, tmplBreadcrumb, tmplSidebar) {
			var pageRaw = Array.isArray(pageXhr) ? pageXhr[0] : (pageXhr || {});
			model.data.navRaw = {};
			model.data.pageRaw = pageRaw;
			return fetchAsync(base + 'web-data/charts/climate/climate-years.json');
		})
		.then(function(meteoClimateYearsXhr) {
			var selectedYear = params.detail;
			return fetchAsync(base + 'web-data/charts/climate/' + (selectedYear || '2026') + '/climate-graph.json')
			.then(function(climateGraphResponse) {
				var additionalData = Array.isArray(climateGraphResponse)
					? climateGraphResponse[0]
					: climateGraphResponse;
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
					climateYears: meteoClimateYearsXhr,
					climateSelectedYear: selectedYear,
					climateData: additionalData
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			});
		})
		.then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
				page: {
					segment: {
						'de': 'klimadiagramme' + '/' + (params.detail || ''),
						'it': 'diagrammi-del-clima' + '/' + (params.detail || ''),
						'lld': 'diagrams-climatics' + '/' + (params.detail || ''),
						'en': 'climate-charts' + '/' + (params.detail || '')
					}
				},
				detail: {
					id: (('' || {}).system_id || '')
				}
			}, $('a.langchange'));
			return ejsmodel;
		})
		.promise();
	};
})();
